<template>
  <md-field :class="getValidationClass(field)">
    <slot />
    <span class="md-error" v-if="field.required === false"
      >You left the field blank.</span
    >
    <span class="md-error" v-else-if="field.minValue === false"
      >must be more or equal to {{ field.$params.minValue.min }}.</span
    >
    <span class="md-error" v-else-if="field.maxValue === false"
      >must be less or equal to {{ field.$params.maxValue.max }}.</span
    >
    <span
      class="md-error"
      v-else-if="
        field.minLength === false &&
          field.$params.minLength.min === field.$params.maxLength.max
      "
      >must be {{ field.$params.minLength.min }} symbols.</span
    >
  </md-field>
</template>

<script>
export default {
  name: "MdInputFieldWithError",
  props: {
    field: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    getValidationClass(field) {
      if (field) {
        return {
          "md-invalid": field.$invalid
        };
      }
    }
  }
};
</script>
